module.exports = __webpack_public_path__ + "img/boxicons.c1f1800d.svg";